import { render } from "./CheckoutWhiteNews.vue?vue&type=template&id=2d205346&scoped=true"
import script from "./CheckoutWhiteNews.vue?vue&type=script&lang=js"
export * from "./CheckoutWhiteNews.vue?vue&type=script&lang=js"

import "./CheckoutWhiteNews.vue?vue&type=style&index=0&id=2d205346&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d205346"]])

export default __exports__